import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LegendItemPicker
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/AccountPerformance/AccountPerformanceChartLegend/LegendItemPicker';
import {
  PERFORMANCE_CHART_LEGEND,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/AccountPerformanceDashboard/AccountPerformance/accountPerformance.consts';

const useStyles = buildUseStyles('AccountPerformanceDashboard', (theme) => ({
  root: {
    display: 'flex',
    columnGap: theme.spacing(2),
  },
}));

export default function AccountPerformanceChartLegend({
  className,
  toggleShowBenchmark,
  showBenchmark,
}) {
  const classes = useStyles();

  return (
    <Box className={classNames(classes.root, className)}>
      {PERFORMANCE_CHART_LEGEND.map((item) => (
        <LegendItemPicker
          name={item.name}
          color={item.color}
          showBenchmark={showBenchmark}
          toggleShowBenchmark={toggleShowBenchmark}
        />
      ))}
    </Box>
  );
}

AccountPerformanceChartLegend.defaultProps = {
  className: '',
  toggleShowBenchmark: null,
  showBenchmark: false,
};

AccountPerformanceChartLegend.propTypes = {
  className: PropTypes.string,
  toggleShowBenchmark: PropTypes.func,
  showBenchmark: PropTypes.bool,
};
